import {useTranslation} from 'react-i18next';
import useOpenState from '../../../../hooks/useOpenState';
import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {user} from '../../../../store/reducers/user';
import Formatter from '../../../../util/formatter';
import * as _ from 'lodash';
import Grid from '@mui/material/Grid';
import {FormControl, FormControlLabel, RadioGroup, Stack} from '@mui/material';
import Typography from '@mui/material/Typography';
import AgyleBlockSwitch from '../../../../components/ui/switch/agyleBlockSwitch';
import moment from 'moment/moment';
import AgyleButton from '../../../../components/ui/buttons/agyleButton';
import Radio from '@mui/material/Radio';
import AddPropertyCommentDialog from './components/addPropertyCommentDialog';
import {usePlansStyles} from './plansStyle';

const getPropertyKey = (name) => {
    const propertyMap = {
        medications: 'medications',
        'additional items': 'additional',
        keys: 'keys',
        handbag: 'handbag',
        'purse/wallet/money': 'purse',
        spectacles: 'spectacles',
        'hearing aids': 'hearingAids',
        wristwatch: 'wristwatch',
        dentures: 'dentures',
        'suitcase/holdall': 'suitcase',
        'walking aid': 'walkingAid',
        jewellery: 'jewellery',
        responsibility: 'cannotAccept',
    };
    return propertyMap[name];
};

const PropertyList = (props) => {
    const classes = usePlansStyles();
    const {t} = useTranslation();

    const {data, setData, disableSave} = props;

    const [isCommentOpen, openComment, closeComment] = useOpenState(false, true);

    const [commentState, setCommentState] = useState(null);
    const [keyState, setKeyState] = useState(null);

    const userObject = useSelector(user);
    const tester = Formatter.formatUserFullName(userObject);

    const addComment = (obj) => {
        let temp = {...commentState[keyState]};
        temp = {
            ...temp,
            comment: obj,
        };

        setData((prevState) => ({
            ...prevState,
            propertyList: {
                ...prevState.propertyList,
                [keyState]: temp,
            },
        }));
        setKeyState(null);
    };

    useEffect(() => {
        let tempPropertyList = {...data.propertyList};
        const idOfCheckedOption = _.filter(
            data.propertyList,
            (property) =>
                property.options &&
                property.checked === false &&
                property.checkedOption !== null,
        );
        let tempProperties;
        if (idOfCheckedOption.length > 0) {
            _.map(idOfCheckedOption, (property, key) => {
                const propertyName = getPropertyKey(property.name);
                tempProperties = {...tempPropertyList[propertyName]};

                tempProperties = {
                    ...tempProperties,
                    checkedOption: null,
                };

                tempPropertyList = {
                    ...tempPropertyList,
                    [propertyName]: tempProperties,
                };
            });

            setData((prevState) => ({
                ...prevState,
                propertyList: tempPropertyList,
            }));
        }
    }, [data.propertyList]);

    return (
        <Grid container>
            {_.map(data.propertyList, (property, key) => {
                return (
                    <Stack
                        key={property.name}
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        className={classes.switchRow}
                        sx={{width: '100%', mb: 1, flexWrap: 'wrap'}}
                    >
                        <Grid item xs={12} sm={6} md={8} sx={{pl: 1, py: 0.5}}>
                            <Typography variant="body1" component="div">
                                {t(property.question)}
                            </Typography>
                        </Grid>

                        <Stack
                            ml={{
                                xs: 'auto',
                                md: 0,
                            }}
                            xs={12}
                            md={6}
                            direction="row"
                            alignItems="center"
                            justifyContent={{
                                xs: 'center',
                                sm: 'flex-end',
                            }}
                        >
                            <Grid
                                item
                                xs={12}
                                style={{flexBasis: 'content'}}
                                sx={{py: 0.5}}
                            >
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    className={classes.switchBackground}
                                >
                                    <FormControlLabel
                                        control={
                                            <AgyleBlockSwitch
                                                onChange={(e) => {
                                                    setData((prevState) => ({
                                                        ...prevState,
                                                        propertyList: {
                                                            ...prevState.propertyList,
                                                            [key]: {
                                                                ...property,
                                                                checked: e,
                                                                checkedBy: prevState.propertyList[key].checked
                                                                    ? null
                                                                    : tester,
                                                                checkedDate: prevState.propertyList[key].checked
                                                                    ? null
                                                                    : moment(),
                                                            },
                                                        },
                                                    }));
                                                }}
                                                value={property.checked}
                                                nullState={property.name !== 'responsibility'}
                                                style={{marginRight: 10}}
                                                customLabels={!true ? {no: t('N/R')} : null}
                                                disabled={disableSave}
                                            />
                                        }
                                        sx={{pl: 1}}
                                    />
                                </Stack>
                            </Grid>
                            <Grid
                                item
                                xs={7}
                                style={{flexBasis: 'content'}}
                                sx={{py: 0.5, ml: 2, mr: 0.5}}
                            >
                                <AgyleButton
                                    size={'small'}
                                    variant="contained"
                                    style={{marginLeft: '8px'}}
                                    onClick={() => {
                                        openComment();
                                        setCommentState({
                                            [key]: property,
                                        });
                                        setKeyState(key);
                                    }}
                                    disabled={disableSave}
                                >
                                    {t('+ Comment')}
                                </AgyleButton>
                            </Grid>
                        </Stack>

                        {property.options && property.checked && (
                            <Grid
                                item
                                xs={12}
                                sx={{px: 2}}
                                className={classes.propertyListOptionRow}
                            >
                                <FormControl>
                                    <RadioGroup
                                        row
                                        value={property.checkedOption}
                                        onChange={(e) => {
                                            setData((prevState) => ({
                                                ...prevState,
                                                propertyList: {
                                                    ...prevState.propertyList,
                                                    [key]: {
                                                        ...property,
                                                        checkedOption: e.target.value,
                                                    },
                                                },
                                            }));
                                        }}
                                    >
                                        {property.options.map((option) => {
                                            return (
                                                <FormControlLabel
                                                    key={option.id}
                                                    value={option.value}
                                                    control={<Radio/>}
                                                    label={option.name}
                                                />
                                            );
                                        })}
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        )}

                        <Grid item xs={12} style={{background: 'grey'}} sx={{px: 2}}>
                            {property.comment && (
                                <Typography variant="body1" component="div" sx={{py: 0.5}}>
                                    {property.comment}
                                </Typography>
                            )}
                        </Grid>
                    </Stack>
                );
            })}

            {isCommentOpen &&
                <AddPropertyCommentDialog
                    {...props}
                    open={isCommentOpen}
                    onClose={closeComment}
                    setCommentState={setCommentState}
                    addComment={addComment}
                    index={keyState}
                />
            }
        </Grid>
    );
};

export default PropertyList;